(function () {
    'use strict';

    angular.module("imApp").factory("invoiceMethodService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1763,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1764,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
